<template>
    <div>
    </div>
</template>

<script>

export default {
    data() {
        return {
        };
    },
    mounted() {
        if(this.$route.query.redirectPage === 'BINDING'){
            this.$router.push({
                name: 'binding',
                query: { timestamp: new Date().getTime() }
            });
        }
      
    },
    watch: {
       
    },
    methods: {
    }
};
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/pages/liffRedirect/index.vue